export const APIImobsaleUrl = 'https://api.jordaoimobiliaria.com.br/v1/venda/';
export const APICadimo5Url = 'https://cadimo.imobsoft.com.br:8052/';
export const TokenAPI = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImFwaSBqb3JkYW8gaW1vYmlsaWFyaWEiLCJpYXQiOjE1MTYyMzkwMjJ9.tTAoU2CGJGcCgse_VUBfcstinnZfD9wu1EClrJCqQjo';
export const TokenCadimo5Api = btoa('jordao:XVhQJmIyGel6Oa3c');
export const TokenConta = 'XVhQJmIyGel6Oa3c';
export const MODALIDADE_ALUGUEL = 'aluguel';
export const MODALIDADE_VENDA = 'venda';
export const METODOS = {
    "aluguel" : {
        'busca': 'BuscaImoveis',
        'tipos': 'CarregaTipos',
        'tiposFinalidade': 'CarregaTiposPorFinalidade',
        'destaques': 'CarregaDestaques',
        'detalhes': 'CarregaDetalhes/',
        'destaquesEspeciais': 'CarregaDestaques',
        'caracteristicas': 'CarregaCaracteristicas',
        'caracteristicasCondominio': 'CarregaCaracteristicasCondominio',
        'buscaEndereco': 'CarregaBairrosCidades',
    },
    "venda" : {
        'busca': 'imoveis',
        'tipos': 'tiposImoveisOptions',
        'tiposFinalidade': 'tiposImoveisDistintosOptions',
        'destaques': 'destaques',
        'detalhes': 'detalhes?codigo=',
        'destaquesEspeciais': 'destaqueEspecial',
        'caracteristicas': 'caracteristicasOptions',
        'caracteristicasCondominio': 'caracteristicasCondominioOptions',
        'buscaEndereco': 'buscaEndereco?palavra=',
    }
};